{
  "pt": {
    "task": {
      "actions": {
        "create": "Tarefa",
        "create_and_send": "Criar e enviar",
        "delete": "Eliminar tarefa",
        "open_in_project": "Abrir a tarefa no projeto",
        "remove_from_unit": "Remover a tarefa desta unidade",
        "save_as_draft": "Guardar como rascunho",
        "update": "Editar tarefa"
      },
      "attributes": {
        "assignments_count": "Atribuições",
        "category": "Forma de concluir",
        "created_at": "Criado em",
        "description": "Descrição",
        "title": "Título",
        "units": "Unidades"
      },
      "categories": {
        "confirmation": "Confirmação",
        "upload": "Carregamento de documento"
      },
      "categories_info": {
        "confirmation": "O responsável marca a tarefa assim que estiver feita.",
        "upload": "O responsável tem de carregar um documento para concluir a tarefa."
      },
      "confirm": {
        "delete_body": "A tarefa desaparece, e todas as suas atribuições também: {assignments} em {units}.",
        "delete_header": "Eliminar «{title}»?",
        "delete_silent": "Ninguém é notificado, e as notificações já enviadas não são retiradas.",
        "remove_from_unit_body": "Cada responsável por «{title}» em {unit} perde-a. A tarefa e as suas outras unidades ficam iguais.",
        "remove_from_unit_customers": "Os clientes de {unit} deixam de a ver no seu portal.",
        "remove_from_unit_header": "Remover esta tarefa de {unit}?"
      },
      "filters": {
        "phase_none": "Sem fase"
      },
      "labels": {
        "assignments_count": "{count} atribuição | {count} atribuições",
        "created_by": "Criado por {name} · {date}",
        "created_on": "Criado em {date}",
        "no_tasks": "Ainda não há tarefas para este projeto.",
        "required": "Este campo é obrigatório",
        "set_all_assignees": "Definir para o responsável | Definir para os {count} responsáveis",
        "still_to_do": "{count} por fazer",
        "units_count": "{count} unidade | {count} unidades",
        "units_required": "Selecione pelo menos uma unidade"
      },
      "toasts": {
        "create": "Tarefa criada",
        "delete": "Tarefa eliminada",
        "remove_from_unit": "Tarefa removida desta unidade",
        "update": "Tarefa atualizada"
      }
    }
  }
}
